
<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field != 'active' && col.field != 'lab' && col.field != 'machine' && col.field!='autoProcessing'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active' || col.field == 'autoProcessing'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
        <td *ngIf="col.field == 'machine' ">
          {{rowData[col.field].name}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" pButton class="h-2rem" icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" position="top" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade" [modal]="true" [style]="{'width':'600px'}"
     [contentStyle]="{'overflow':'auto'}" [baseZIndex]="1000">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <label>{{col.header}}</label>
        <div *ngIf="col.field == 'name'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>

        <div *ngIf="col.field == 'lab'">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab"  placeholder="Select a Lab"
            optionLabel="name" [showClear]="true" (onChange)="getDropDetailsBySelectedLab()"></p-dropdown>
        </div>
        <div *ngIf="col.field == 'handler'">
          <p-dropdown [options]="handlerOptions" [(ngModel)]="selectedHandlerOption" placeholder="Select a Handler"
          optionLabel="name" [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == 'machine'">
          <p-dropdown [options]="machineOptions" [(ngModel)]="selectedMachineType" placeholder="Select a Machine"
              [style]="{'width':'280px'}" optionLabel="name" [showClear]="true" ></p-dropdown>
        </div>
        <div *ngIf="col.field == 'regexRunID'">
          <input pInputText class="form-control" [(ngModel)]="regexRunIdValue" [style]="{'width':'280px'}"
            (change)="masterList[col.field]=masterList[col.field].trim()">
      </div>
      <div *ngIf="col.field == 'location'">
        <input pInputText class="form-control" [(ngModel)]="locationValue" [style]="{'width':'280px'}"
          (change)="masterList[col.field]=masterList[col.field].trim()">
    </div>
    <div *ngIf="col.field == 'autoProcessing'">
      <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
    </div>
    <div *ngIf="col.field == 'active'">
      <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
    </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterListData()"
      label="Save" class="h-2rem"></button>
  </div>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
